import { render } from "./SuccessEmailVerificationPage.vue?vue&type=template&id=5c87f315&scoped=true"
import script from "./SuccessEmailVerificationPage.vue?vue&type=script&lang=js"
export * from "./SuccessEmailVerificationPage.vue?vue&type=script&lang=js"

import "./SuccessEmailVerificationPage.vue?vue&type=style&index=0&id=5c87f315&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c87f315"]])

export default __exports__